module.exports = __webpack_public_path__ + "static/media/boy-2.a11012b6.png";